<template>
  <div>
    <div class="mb-3">
      <v-btn color="primary" small @click="newChat()" v-if="!openNewChatForm">
        ثبت پیام جدید
      </v-btn>
      <trade-request-chats-with-admin-form
        v-else
        @closeChatForm="closeChatForm"
        @getTradeRequestChatsWithAdmin="getTradeRequestChatsWithAdmin"
      >
      </trade-request-chats-with-admin-form>
    </div>
    <v-row v-for="(chat, index) in tradeRequestChatWithAdminList" :key="index">
      <v-col cols="12">
        <v-card
          outlined
          :color="chat.isAdmin ? 'orange lighten-5' : 'light-blue lighten-5'"
          max-width="90%"
          :class="chat.isAdmin ? 'float-left' : 'float-right'"
          v-if="!openEditChat || chat.id != selectedChatForEdit.id"
        >
          <v-card-text>
            <div class="d-flex flex-row justify-content-between">
              <div>
                <b>{{ chat.userFullName }}</b>
                <span class="mr-2">{{ chat.createdTimeUtc | moment }}</span>
                <small v-if="chat.edited">(ویرایش شده)</small>
              </div>
              <div v-if="!chat.isAdmin">
                <v-btn
                  icon
                  color="primary"
                  x-small
                  @click="editChat(chat)"
                  v-if="!chat.isRead"
                >
                  <v-icon> mdi mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" x-small @click="deleteChat(chat)">
                  <v-icon> mdi mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="my-2">
              <strong>{{ chat.message }}</strong>
            </div>
            <div v-if="chat.attachments.length > 0">
              <div class="d-flex flex-row flex-wrap">
                <div
                  class="m-3"
                  v-for="(attachment, index) in chat.attachments"
                  :key="index"
                >
                  <v-img
                    :src="attachment.thumbnailFileUrl"
                    width="100"
                    height="100"
                    class="attachment"
                    @click="openImage(attachment.fileUrl)"
                  ></v-img>
                </div>
              </div>
            </div>
            <div v-if="chat.isRead">
              <span>خوانده شده</span>
              <span class="mr-2">{{ chat.readTimeUtc | moment }}</span>
            </div>
          </v-card-text>
        </v-card>
        <trade-request-chats-with-admin-form
          v-else-if="openEditChat && chat.id == selectedChatForEdit.id"
          @closeChatForm="closeChatForm"
          @getTradeRequestChatsWithAdmin="getTradeRequestChatsWithAdmin"
          :chatIsEdit="true"
          :selectedChatForEdit="selectedChatForEdit"
        >
        </trade-request-chats-with-admin-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TradeRequestChatsWithAdminForm from './TradeRequestChatsWithAdminForm';
import Helper from '@/core/helpers';
const tradeRequestChatWithAdminRepository = () =>
  RepoFactory.get('tradeRequestChatWithAdmin');
import { RepoFactory } from '@/baseRepository/Factory';
export default {
  components: {
    TradeRequestChatsWithAdminForm,
  },
  props: {
    tradeRequestChatWithAdminList: {
      default: undefined,
      type: Array,
    },
  },
  data() {
    return {
      openNewChatForm: false,
      openEditChat: false,
      selectedChatForEdit: null,
    };
  },
  methods: {
    openImage(url) {
      window.open(url, '_blank');
    },
    newChat() {
      this.openNewChatForm = true;
      this.openEditChat = false;
      this.selectedChatForEdit = null;
    },
    closeChatForm() {
      this.openNewChatForm = false;
      this.openEditChat = false;
      this.selectedChatForEdit = null;
    },
    getTradeRequestChatsWithAdmin() {
      this.$emit('getTradeRequestChatsWithAdmin');
    },
    editChat(chat) {
      this.openEditChat = true;
      this.selectedChatForEdit = chat;
      this.openNewChatForm = false;
    },
    deleteChat(item) {
      this.$dialog.warning({
        text: `آیا از حذف پیام اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              tradeRequestChatWithAdminRepository()
                .deleteTradeRequestChatsWithAdminById(
                  item.id,
                  this.$store.getters.tradeBaseUrl
                )
                .then(() => {
                  this.getTradeRequestChatsWithAdmin();
                  this.$dialog.message.success('با موفقیت حذف گردید', {
                    position: 'top-left',
                  });
                  loader.hide();
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                  loader.hide();
                });
            },
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment {
  cursor: pointer;
}
</style>
